// extracted by mini-css-extract-plugin
export default {"compactHeader":"index_compactHeader__lVFty","outlook":"index_outlook__3dRAK"};